import { all } from 'redux-saga/effects'
import { authSaga } from './authSaga'
import { locationSaga } from './locationSaga'
import { recordsSaga } from './recordsSaga'
import { carePlanSaga } from './carePlanSaga'
import { cgmSaga } from './cgmSaga'
import { landingPageSaga } from './landingPageSaga'
import { authenticationSaga } from './authenticationSaga'
export default function* rootSaga() {
  yield all([
    authSaga(),
    locationSaga(),
    recordsSaga(),
    carePlanSaga(),
    cgmSaga(),
    landingPageSaga(),
    authenticationSaga(),
    // Add other sagas here as needed
  ])
}
